import { render, staticRenderFns } from "./KubeStateMetrics.vue?vue&type=template&id=0cdef8ce&scoped=true"
import script from "./KubeStateMetrics.vue?vue&type=script&lang=js"
export * from "./KubeStateMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdef8ce",
  null
  
)

export default component.exports